// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3baf6595","729":"b8e82c2b","770":"91880a37","918":"2afbe00a"}[chunkId] + ".chunk.js";
};